import React, { useCallback, useEffect, useRef } from "react";
import { Link } from "./link";
import { normalizeRelativePath } from "../utility/paths";
import ArrowRight from "../icons/vector-right.svg";
import ProductDetailInfo from "./molecules/product-detail-info";
import Modal from "./modules/modal";
import ProductDetailImage from "./molecules/product-detail-header";
import safeSlufigy from "../utility/safe-slugify";

const AccessoriesAndConsumablesModal = ({
  show,
  onHide,
  babelProdotto,
  productApp,
  location,
  labelManagerLabels,
  tags,
  liferayProductNotes,
  badge,
  extraServices,
  priceData,
  storeLink,
  bannerPromo,
  onClickWtb,
}) => {
  const {
    compatibleProducts,
    hasDirectProducts,
    lineId,
    familiesIds,
    productTitleNoFamilyAC,
    pageLine,
    compatibleLines,
    compatiblePageLines,
  } = babelProdotto;

  const ref = useRef(null);

  useEffect(() => {
    if (show && ref.current) {
      ref.current.focus();
    }
  }, [show]);

  const closeDialog = useCallback(() => {
    if (ref.current) {
      onHide();
    }
  }, [onHide]);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        closeDialog();
      }
    },
    [closeDialog]
  );

  const linkProductPage = normalizeRelativePath(
    `/${[
      babelProdotto.pageLine.slug.startsWith("/")
        ? babelProdotto.pageLine.slug.substring(1)
        : babelProdotto.pageLine.slug,
      babelProdotto.key_prod,
      babelProdotto.productName.toLowerCase(),
    ]
      .map(safeSlufigy)
      .join("/")}/`
  );

  const productFamily = familiesIds?.length ? familiesIds[0] : null;
  const lineProductName = pageLine?.pageNameInCardProdotto
    ? pageLine.pageNameInCardProdotto
    : pageLine?.pageName;

  const productTitle =
    lineId === 333 && !(familiesIds?.length > 0) && productTitleNoFamilyAC
      ? productTitleNoFamilyAC
      : lineProductName;

  const productFamilyTitle = familiesIds?.length > 0 && productFamily.title;

  const compatibleLinesTitle = !!compatiblePageLines?.length
    ? compatiblePageLines
        ?.filter((line) => line?.pageLine?.title)
        .map((line) => {
          return {
            title: line?.pageLine?.title,
          };
        })
        .concat(
          compatibleLines?.reduce((result, line) => {
            const isDuplicate = compatiblePageLines
              ?.filter((line) => line?.pageLine?.title)
              ?.some((item) => `${item?.pageLine?.lineId}` === `${line?.id}`);
            if (!isDuplicate) {
              result.push(line);
            }
            return result;
          }, [])
        )
        ?.map((line) => line?.title)
        .join(", ")
    : compatibleLines?.map((line) => line?.title).join(", ");

  return (
    <Modal>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <div
        ref={ref}
        className={`accessories-and-consumables-modal${
          show ? " accessories-and-consumables-modal--show" : ""
        }`}
        role="dialog"
        aria-hidden={!show}
        onKeyDown={onKeyDown}
      >
        <div className="accessories-and-consumables-modal__dialog" role="document">
          <div className="accessories-and-consumables-modal__alert ">
            <div className="accessories-and-consumables-modal__alert-content">
              <div className="accessories-and-consumables-modal__top-bar">
                <button
                  className="accessories-and-consumables-modal__top-bar-close"
                  onClick={closeDialog}
                >
                  {labelManagerLabels.close}
                </button>
                <div className="accessories-and-consumables-modal__top-bar-title">
                  {labelManagerLabels.productPreview}
                </div>
              </div>

              <section className="pdp-main-info">
                <ProductDetailImage
                  product={babelProdotto}
                  app={productApp}
                  tags={tags}
                  badge={badge}
                  bannerPromo={bannerPromo}
                />
                <ProductDetailInfo
                  product={babelProdotto}
                  priceData={priceData}
                  liferayProductNotes={liferayProductNotes}
                  location={location}
                  extraServices={extraServices}
                  origin="aec"
                  onClickWtb={onClickWtb}
                  storeLink={storeLink}
                  productTitle={productTitle}
                  productFamilyTitle={productFamilyTitle}
                  compatibleProducts={compatibleProducts}
                  compatibleLinesTitle={compatibleLinesTitle}
                  hasDirectProducts={hasDirectProducts}
                />
              </section>
              <div className="accessories-and-consumables-modal__product-page  flex-column flex-md-row">
                <Link
                  to={linkProductPage}
                  className="accessories-and-consumables-modal__product-link"
                >
                  {labelManagerLabels.goToProductPage}
                  <ArrowRight />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AccessoriesAndConsumablesModal;
